import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { FiMail, FiPhone, FiMapPin } from 'react-icons/fi';
import { useModal } from '../services/ModalService';
import './Footer.css';

const Footer = () => {
  const { openContactModal } = useModal();
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const handleContactClick = (e) => {
    e.preventDefault();
    openContactModal('General Inquiry', 'Footer - Contact Link');
  };

  const handleTermsClick = (e) => {
    e.preventDefault();
    navigate('/terms-of-service');
    window.scrollTo(0, 0);
  };

  const handlePrivacyClick = (e) => {
    e.preventDefault();
    navigate('/privacy-policy');
    window.scrollTo(0, 0);
  };

  return (
    <footer className="footer">
      <div className="footer-background">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
      </div>

      <div className="container">
        <div className="footer-content">
          <div className="footer-left">
            <motion.div 
              className="footer-logo"
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <h3 className="logo-text">RKube Inc</h3>
              {/* <p className="logo-tagline">Strategic Financial Partners</p> */}
            </motion.div>
          </div>

          <div className="footer-right">
            <motion.nav 
              className="footer-nav"
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              <ul className="footer-links">
                <li>
                  <button 
                    className="footer-link"
                    onClick={handleContactClick}
                  >
                    Contact
                  </button>
                </li>
                <li>
                  <button 
                    className="footer-link"
                    onClick={handleTermsClick}
                  >
                    Terms of Service
                  </button>
                </li>
                <li>
                  <button 
                    className="footer-link"
                    onClick={handlePrivacyClick}
                  >
                    Privacy Policy
                  </button>
                </li>
              </ul>
            </motion.nav>
          </div>
        </div>

        <motion.div 
          className="footer-bottom"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <div className="footer-divider"></div>
          <div className="footer-copyright">
            <p>&copy; {currentYear} RKube Inc. All rights reserved.</p>
            {/* <p className="footer-disclaimer">
              Professional financial services, IT services and strategic partnerships for business growth.
            </p> */}
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer; 